import { render, staticRenderFns } from "./DialogPreviewFile.vue?vue&type=template&id=4abecbfc&scoped=true&"
import script from "./DialogPreviewFile.vue?vue&type=script&lang=js&"
export * from "./DialogPreviewFile.vue?vue&type=script&lang=js&"
import style0 from "./DialogPreviewFile.vue?vue&type=style&index=0&id=4abecbfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abecbfc",
  null
  
)

export default component.exports